import { render, staticRenderFns } from "./ClassroomInstructor.vue?vue&type=template&id=5aa9bff6&scoped=true"
import script from "./ClassroomInstructor.vue?vue&type=script&lang=js"
export * from "./ClassroomInstructor.vue?vue&type=script&lang=js"
import style0 from "./ClassroomInstructor.vue?vue&type=style&index=0&id=5aa9bff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9bff6",
  null
  
)

export default component.exports